import $ from "jquery";

export const Puzzle = () => {
  const isPuzzle = $("#puzzle").length > 0;
  if (!isPuzzle) return false;

  const CFG = window.CFG;
  const CFG_AJAX = window.CFG_AJAX.check_code;

  const SECURITY = {
    MAX_CODE_LENGTH: 100,
    MIN_CODE_LENGTH: 3,
    ALLOWED_PATTERN: /^[a-zA-Z0-9\-_ ,@#.+*]+$/,
    RATE_LIMIT_MS: 1000,
    RATE_LIMIT_ENABLED: false,
  };

  const elms = {
    inputCode: $(".js-input-code"),
    submitCode: $(".js-submit-code"),
    resetPuzzle: $(".js-reset-puzzle"),
    errorMessage:
      $(".js-error-message") || $("<div class='js-error-message'></div>"),
  };

  let lastRequestTime = 0;
  let isSubmitting = false;
  let puzzleIndex = 0;

  /**
   * Validate user input
   *
   * @param {string} input
   * @returns {object} { valid: boolean, sanitized: string, error: string }
   */
  const validateInput = (input) => {
    const sanitized = String(input).trim();

    if (!sanitized || sanitized.length === 0) {
      return {
        valid: false,
        sanitized: "",
        error: "Code cannot be empty",
      };
    }

    if (sanitized.length < SECURITY.MIN_CODE_LENGTH) {
      return {
        valid: false,
        sanitized: "",
        error: `Code must be at least ${SECURITY.MIN_CODE_LENGTH} characters`,
      };
    }

    if (sanitized.length > SECURITY.MAX_CODE_LENGTH) {
      return {
        valid: false,
        sanitized: "",
        error: `Code must not exceed ${SECURITY.MAX_CODE_LENGTH} characters`,
      };
    }

    // Prevents XSS by allowing only safe characters
    if (!SECURITY.ALLOWED_PATTERN.test(sanitized)) {
      return {
        valid: false,
        sanitized: "",
        error:
          "Code contains invalid characters. Allowed: letters, numbers, spaces, and common symbols (- _ , @ # . + *)",
      };
    }

    return {
      valid: true,
      sanitized: sanitized,
      error: "",
    };
  };

  /**
   * Check rate limiting
   *
   * @returns {boolean}
   */
  const checkRateLimit = () => {
    const now = Date.now();
    const timeSinceLastRequest = now - lastRequestTime;

    if (timeSinceLastRequest < SECURITY.RATE_LIMIT_MS) {
      return false;
    }

    lastRequestTime = now;
    return true;
  };

  /**
   * Display error message
   *
   * @param {string} message
   */
  const showError = (message) => {
    const safeMessage = $("<div>").text(message).html();
    elms.errorMessage.html(safeMessage).show();

    setTimeout(() => {
      elms.errorMessage.fadeOut();
    }, 5000);
  };

  const clearError = () => {
    elms.errorMessage.hide().html("");
  };

  /**
   * Submit code to server
   */
  const checkCode = () => {
    if (isSubmitting) {
      return;
    }

    clearError();

    const rawCode = elms.inputCode.val();
    const validation = validateInput(rawCode);

    if (!validation.valid) {
      showError(validation.error);
      return;
    }

    if (SECURITY.RATE_LIMIT_ENABLED && !checkRateLimit()) {
      showError("Please wait before submitting again");
      return;
    }

    isSubmitting = true;
    elms.submitCode.prop("disabled", true).addClass("loading");
    puzzleIndex = $("body").attr('data-puzzle-index') || 0;

    $.ajax({
      url: CFG.ajaxURL,
      type: "POST",
      dataType: "json",
      timeout: 10000,
      data: {
        action: CFG_AJAX.action,
        code: validation.sanitized,
        nonce: CFG_AJAX.nonce,
        page_id: CFG_AJAX.current_page_id,
        puzzle_index: puzzleIndex,
      },
      success: (response) => {
        if (response.success) {
          const params = new URLSearchParams(window.location.search);
          params.set('status', 'completed');
          if (typeof response.data.puzzle_index !== 'undefined') {
            params.set('pid', response.data.puzzle_index);
          }
          if (typeof response.data.answer_index !== 'undefined') {
            params.set('aid', response.data.answer_index);
          }
          const newUrl = `${window.location.pathname}?${params.toString()}`;
          window.history.replaceState({}, '', newUrl);
          window.location.replace(newUrl);
        } else {
          const params = new URLSearchParams(window.location.search);
          params.set('status', 'failed');
          if (typeof response.data.puzzle_index !== 'undefined') {
            params.set('pid', response.data.puzzle_index);
          }
          const newUrl = `${window.location.pathname}?${params.toString()}`;
          window.history.replaceState({}, '', newUrl);
          window.location.replace(newUrl);
        }
      },
      error: (xhr, status) => {
        let errorMsg = "Connection error. Please try again.";

        if (status === "timeout") {
          errorMsg = "Request timed out. Please try again.";
        } else if (xhr.status === 403) {
          errorMsg = "Access denied. Please refresh the page.";
        } else if (xhr.status >= 500) {
          errorMsg = "Server error. Please try again later.";
        }

        showError(errorMsg);
      },
      complete: () => {
        isSubmitting = false;
        elms.submitCode.prop("disabled", false).removeClass("loading");
      },
    });
  };

  elms.inputCode.on("input", (e) => {
    const value = $(e.target).val();
    const validation = validateInput(value);

    if (!validation.valid && value.length > 0) {
      $(e.target).addClass("invalid");
    } else {
      $(e.target).removeClass("invalid");
    }
  });

  elms.submitCode.on("click", (e) => {
    e.preventDefault();
    checkCode();
  });

  elms.inputCode.on("keyup", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      checkCode();
    }
  });

  elms.resetPuzzle.on("click", (e) => {
    e.preventDefault();
    // Preserve the existing 'lang' URL parameter (if present) when resetting the puzzle
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get('lang');
    window.location.href = window.location.pathname + (langParam ? `?lang=${langParam}` : '');
  });
};
